import useLayout from "@/lib/layout/useLayout";
import { Divider, Tab, Tabs } from "@heroui/react";
import {
    createFileRoute,
    Link,
    Outlet,
    useMatch,
} from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/dashboard/enrollment")({
    component: RouteComponent,
});

function RouteComponent() {
    const { setLayoutState } = useLayout();
    useEffect(() => {
        setLayoutState("full_screen");
    }, [setLayoutState]);

    const fields = useMatch({
        from: "/dashboard/enrollment/fields",
        shouldThrow: false,
    });
    const contracts = useMatch({
        from: "/dashboard/enrollment/contracts",
        shouldThrow: false,
    });

    const tab = [fields, contracts]
        ?.find((x) => !!x)
        ?.fullPath?.split("/")
        .pop();

    return (
        <div>
            <Tabs variant="underlined" color="primary" selectedKey={tab}>
                <Tab
                    title="Field Enrollment"
                    key="fields"
                    as={Link}
                    // @ts-expect-error ts(2322 )
                    to="/dashboard/enrollment/fields"
                ></Tab>
                <Tab
                    title="Contracts"
                    key="contracts"
                    as={Link}
                    // @ts-expect-error ts(2322 )
                    to="/dashboard/enrollment/contracts"
                ></Tab>
            </Tabs>
            <Divider />
            <Outlet />
        </div>
    );
}
